/* eslint-disable angular/document-service */
import {signUpLinkedInConnect, signUpRequestAccess} from '../segment'
;(function module() {
  angular.module('app.ui.form.ctrls').controller('AboutYouController', [
    '$location',
    'usSpinnerService',
    'logger',
    '$window',
    'userService',
    '$scope',
    '$timeout',
    'SharedApi',
    'EmployersApi',
    'CandidateProfileApi',
    '$uibModal',
    'socket',
    function controller(
      $location,
      usSpinnerService,
      logger,
      $window,
      userService,
      $scope,
      $timeout,
      SharedApi,
      EmployersApi,
      CandidateProfileApi,
      $uibModal,
      socket
    ) {
      let vm = this

      socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', data => {
        $timeout(() => {
          if (vm.user.id === data && $location.url().contains('profile')) {
            vm.initializeAboutYouPage()
          }
        }, 2000)
      })
      const approvalStatusEnum = {
        NEW_USER: 'New User',
        PENDING_APPROVAL: 'Pending Approval',
        APPROVED: 'Approved',
        REJECTED: 'Rejected',
        LOCKED: 'Locked',
      }

      const startSpinner = () => usSpinnerService.spin('spinner-2')

      const stopSpinner = () => usSpinnerService.stop('spinner-2')

      vm.connectToLinkedIn = candidateId => {
        signUpLinkedInConnect()
        $window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77np1itngwj5tl&redirect_uri=${process.env.LEXSTEP_URL}/api/v1/linkedin/callback&state=${candidateId}&scope=r_liteprofile%20r_emailaddress`
      }

      vm.isFormValid = () => {
        if (
          ((!vm.fetchEmployer &&
            vm.legalEmployerTypes.includes(({isSelected}) => isSelected)) ||
            vm.fetchEmployer) &&
          vm.candidate.pqe &&
          vm.jurisdictionShow &&
          vm.selectedPracticesShow &&
          vm.selectedLocation &&
          vm.candidate.nationality &&
          vm.candidate.university &&
          vm.candidate.phone &&
          vm.candidate.location &&
          vm.candidate.employer &&
          !vm.phoneError &&
          (vm.candidate.resume ||
            vm.candidate.linkedinUrl ||
            vm.candidate.linkedinData ||
            vm.candidate.sraId)
        ) {
          return true
        }

        vm.accessRequested = true
        logger.notify(
          'error',
          'Please complete all fields before requesting access'
        )
        return false
      }

      vm.applyRequestAccess = async () => {
        if (vm.isFormValid()) {
          const payload = {approvalStatus: approvalStatusEnum.PENDING_APPROVAL}
          const {
            status,
          } = await CandidateProfileApi.updateCandidateApprovalStatus(
            vm.candidate.id,
            payload
          )
          if (status === 200) {
            vm.requestAccessClass = 'btn btn-lg btn-info disabled'
            vm.candidate.isNewUser = false
            signUpRequestAccess(
              vm.candidate.nationality.code,
              vm.candidate.location,
              vm.candidate.phone,
              vm.candidate.pqe,
              vm.candidate.legalJurisdictions,
              vm.candidate.specialties,
              vm.isEnglandWalesSelected || false,
              Boolean(vm.candidate.linkedinUrl),
              vm.candidate.resume
            )
            $scope.$apply()
          }
        }
      }

      const resetEmployerLegalTypes = () => {
        vm.legalEmployerTypes = vm.legalEmployerTypes.map(employerType => {
          return {
            name: employerType.name,
            id: employerType.id,
            isSelected: false,
          }
        })
      }

      const selectEmployerLegalTypes = name => {
        vm.legalEmployerTypes = vm.legalEmployerTypes.map(employerType => {
          return name === employerType.name
            ? {name: employerType.name, id: employerType.id, isSelected: true}
            : {name: employerType.name, id: employerType.id, isSelected: false}
        })
      }

      vm.onEmployerTypeSelected = async selectedEmployerType => {
        // eslint-disable-next-line no-negated-condition

        vm.legalEmployerTypes = vm.legalEmployerTypes.map(employerType => {
          return selectedEmployerType.name === employerType.name
            ? {name: employerType.name, id: employerType.id, isSelected: true}
            : {name: employerType.name, id: employerType.id, isSelected: false}
        })

        const employerDto = selectedEmployerType.id
          ? {
              employer: vm.candidate.employer,
              employerProfessions: ['law'],
              employerSpecialties: [selectedEmployerType.id],
              employerCategories: [2],
            }
          : {employer: vm.candidate.employer}

        await CandidateProfileApi.updateProfileData(
          vm.candidate.id,
          employerDto
        )

        vm.isNewCandidate.employer = vm.candidate.employer
        vm.fetchEmployer = true
        $scope.$apply()
      }

      let employerUpdateInProgress = false
      let universityUpdateInProgress = false

      vm.setEmployerTypesOpacity = () => {
        if (vm.fetchEmployer) {
          return {
            opacity: '70%',
          }
        }
      }

      const fetchSelectedEmployer = async () => {
        if (vm.candidate.employer && vm.candidate.employer.id) {
          try {
            vm.fetchEmployer = await EmployersApi.getEmployerById(
              vm.candidate.employer.id
            )

            if (vm.fetchEmployer) {
              resetEmployerLegalTypes()
              const employerLegalCategory = vm.fetchEmployer.data.categories.find(
                category => category.id === 2
              )

              if (employerLegalCategory) {
                employerLegalCategory.specialties.map(({name}) =>
                  selectEmployerLegalTypes(name)
                )
              } else if (
                vm.fetchEmployer.professions &&
                vm.fetchEmployer.professions.includes(({id}) => id !== 'law')
              )
                selectEmployerLegalTypes('Other')
            }
          } catch (error) {
            console.error('Error fetching employer', error)
          }
        } else {
          vm.fetchEmployer = undefined
        }

        $scope.$apply()
      }

      const updateCandidateEmployer = (oldValue, newValue) => {
        if (
          !employerUpdateInProgress &&
          vm.candidate.employer &&
          oldValue !== newValue
        ) {
          employerUpdateInProgress = true
          $timeout(async () => {
            await fetchSelectedEmployer()
            const employer =
              vm.candidate.employer && vm.candidate.employer.id
                ? vm.candidate.employer.id
                : vm.candidate.employer
            if (
              vm.candidate.employer.id ||
              vm.legalEmployerTypes.includes(({isSelected}) => isSelected)
            ) {
              await CandidateProfileApi.updateProfileData(vm.candidate.id, {
                employer: vm.candidate.employer.id,
              })
              vm.isNewCandidate.employer = vm.candidate.employer.name

              $scope.$apply()
            } else {
              vm.fetchEmployer = undefined
              vm.legalEmployerTypes = vm.legalEmployerTypes.map(
                employerType => {
                  return {
                    id: employerType.id,
                    name: employerType.name,
                    isSelected: false,
                  }
                }
              )
              logger.notify(
                'error',
                `Employer Type must be selected for new employer`
              )
            }

            if (employer) employerUpdateInProgress = false

            $scope.$apply()
          }, 200)
        }
      }

      const updateCandidateUniversity = (oldValue, newValue) => {
        oldValue = oldValue ? JSON.parse(oldValue).name : oldValue
        if (
          !universityUpdateInProgress &&
          vm.candidate.university &&
          oldValue !== newValue
        ) {
          universityUpdateInProgress = true
          $timeout(async () => {
            const university =
              vm.candidate.university && vm.candidate.university.id
                ? vm.candidate.university.id
                : vm.candidate.university

            const existingSchool = vm.schoolList.find(
              ({name}) => name === university
            )
            let school = existingSchool
            if (!existingSchool) {
              const {
                data: newSchool,
                status: statusSchool,
              } = await SharedApi.addSchool({name: university})
              if (statusSchool === 201) {
                vm.schoolList.push(newSchool)
                school = newSchool
              }
            }

            await CandidateProfileApi.updateProfileData(vm.candidate.id, {
              schoolId: school.id,
            })
            vm.isNewCandidate.university = {
              id: school.id,
              name: school.name,
            }

            if (university) universityUpdateInProgress = false
            $scope.$apply()
          }, 200)
        }
      }

      const updateCandidateNationality = async (oldValue, newValue) => {
        if (oldValue !== newValue && newValue !== 'Select Nationality') {
          const newNationalityCode = newValue
            ? vm.nationalitiesList.find(({name}) => name === newValue).code
            : ''

          const oldNationalityCode = oldValue
            ? vm.nationalitiesList.find(
                ({name}) => name === JSON.parse(oldValue).name
              ).code
            : ''
          if (newNationalityCode !== oldNationalityCode) {
            await CandidateProfileApi.updateProfileData(vm.candidate.id, {
              candidatePreference: {
                nationalities: [newNationalityCode],
              },
            })
          }

          vm.candidate.nationality = vm.nationalitiesList.find(
            ({name}) => name === newValue
          )

          vm.isNewCandidate.nationality = vm.candidate.nationality
        }
      }

      const updateCandidateLocation = async (oldValue, newValue) => {
        if (newValue && Number(oldValue) !== newValue) {
          await CandidateProfileApi.updateProfileData(vm.candidate.id, {
            location: Number(newValue),
          })

          vm.candidate.location = newValue
          vm.isNewCandidate.location = vm.candidate.location
          $scope.$apply()
        }
      }

      vm.candidateUpdate = async (field, event) => {
        var oldValue = event
          ? document
              .querySelectorAll(`#${field}`)[0]
              .getAttribute('previous-value')
          : false
        var newValue = event
          ? document.querySelectorAll(`#${field}`)[0].value
          : false

        switch (field) {
          case 'employer':
            updateCandidateEmployer(oldValue, newValue)
            break
          case 'location':
            updateCandidateLocation(oldValue, newValue)
            break
          case 'university':
            updateCandidateUniversity(oldValue, newValue)
            break
          case 'nationality':
            updateCandidateNationality(oldValue, newValue)
            break
          case 'preferredLocation':
            await CandidateProfileApi.updateProfileData(vm.candidate.id, {
              candidatePreference: {
                preferredLocations: vm.candidateLocationIds,
              },
            })

            break
          case 'specialty':
            await CandidateProfileApi.updateProfileData(vm.candidate.id, {
              candidatePreference: {
                specialtiesByCategory: [
                  {id: 1, specialties: vm.candidateSpecialtyIds},
                ],
              },
            })

            break
          case 'phone':
            vm.phoneError = false
            // eslint-disable-next-line no-case-declarations
            const trimmed = newValue.replace(/\s/g, '')

            if (vm.candidate.phone && oldValue !== trimmed) {
              const phoneRegex = /^\+?\d{1,20}$/
              if (trimmed.match(phoneRegex)) {
                await CandidateProfileApi.updateUserData(vm.candidate.id, {
                  phone: trimmed,
                })
                vm.phoneError = false
                vm.isNewCandidate.phone = trimmed
              } else {
                logger.notify('error', `Please enter a valid phone number`)
                vm.phoneError = true
              }
            }

            break
          case 'pqe':
            if (vm.candidate.pqe && oldValue !== newValue) {
              await CandidateProfileApi.updateProfileData(vm.candidate.id, {
                lawProfile: {
                  qualificationDate: vm.candidate.pqe,
                },
              })
              vm.isNewCandidate.pqe = vm.candidate.pqe
            }

            break

          case 'sraId':
            if (vm.candidate.sraId && oldValue !== newValue) {
              await CandidateProfileApi.updateProfileData(vm.candidate.id, {
                lawProfile: {
                  sraId: vm.candidate.sraId,
                },
              })
              vm.isNewCandidate.sraId = vm.candidate.sraId
            }

            break
          default:
            break
        }
      }

      vm.uploadResumeButton = async (file, oldResume) => {
        startSpinner()
        vm.requestAccessClass = 'btn btn-lg btn-info disabled'
        if (oldResume)
          await CandidateProfileApi.deleteUserResume(vm.candidate.id, oldResume)
        const formData = new FormData()
        formData.append('file', file[0])
        try {
          const {
            data: newResume,
            status,
          } = await CandidateProfileApi.uploadResume(vm.candidate.id, formData)
          if (status === 201) {
            vm.candidate.resume = newResume[newResume.length - 1]
            vm.requestAccessClass = 'btn btn-lg btn-info'
            $scope.$apply()
            logger.notify('success', `Resume uploaded successfully`)
          }
          // eslint-disable-next-line unicorn/prefer-optional-catch-binding
        } catch (error) {
          logger.notify('error', `Error occurred in Resume uploading`)
        }

        stopSpinner()
      }

      vm.openLocationModal = (selectedLocations, event) => {
        if (event) {
          event.preventDefault()
          event.stopPropagation()
        }

        const displayNextButton = true
        const modalInstance = $uibModal.open({
          templateUrl: 'locations-modal.html',
          controller: 'LocationsModalController',
          controllerAs: 'ctrl',
          resolve: {
            locationList: function() {
              return vm.locationsList
            },
            selectedLocations: function() {
              return selectedLocations
            },
            limit: function() {
              return 0
            },
            locationModalHeading: function() {
              return false
            },
            displayNextButton: function() {
              return displayNextButton
            },
          },
        })
        modalInstance.result.then(
          selectedLocations => {
            vm.selectedLocations = selectedLocations
            vm.selectedLocation = selectedLocations.length > 0
            if (vm.selectedLocation) {
              vm.candidate.preferredLocations = angular.copy(selectedLocations)
              vm.candidateLocationIds = vm.candidate.preferredLocations.map(
                ({id}) => id
              )
              vm.candidateUpdate('preferredLocation')
            }
          },
          () => {}
        )
      }

      vm.jurisdictionUpdate = async (event, selectedJurisdiction) => {
        vm.openPracticeModal(vm.selectedPractice, event)
        if (event) {
          event.stopPropagation()
        } else {
          vm.jurisdictionShow = selectedJurisdiction
          vm.selectedJurisdiction = selectedJurisdiction
          vm.isEnglandWalesSelected = vm.selectedJurisdiction.find(
            ({isSelected, name}) =>
              isSelected === true && name === 'England & Wales'
          )
        }
      }

      vm.openPracticeModal = (selectedPractice, event) => {
        if (event) {
          event.preventDefault()
          event.stopPropagation()
        }

        const onlyParentPracticeArea = vm.legalPracticeAreaList.filter(
          ({parentId}) => parentId === null
        )
        const displayNextButton = true
        const practiceModalInstance = $uibModal.open({
          templateUrl: 'practice-area-modal.html',
          controller: 'PracticeAreaController',
          controllerAs: 'ctrl',
          resolve: {
            practiceAreaList: function() {
              return onlyParentPracticeArea
            },
            selectedPractice: function() {
              return selectedPractice
            },
            limit: function() {
              return 20
            },
            isAdminProfile: function() {
              return false
            },
            displayNextButton: function() {
              return displayNextButton
            },
          },
        })
        practiceModalInstance.result.then(
          selectPractices => {
            if (displayNextButton)
              vm.openLocationModal(vm.selectedLocations, event)
            vm.selectPractices = selectPractices
            vm.selectedPracticesShow = selectPractices.length > 0
            if (vm.selectedPracticesShow) {
              vm.candidate.specialties = vm.selectPractices.map(specialty => {
                specialty.isSelected = true
                return specialty
              })
              vm.candidateSpecialtyIds = vm.selectPractices.map(({id}) => id)
              vm.candidateUpdate('specialty')
            }
          },
          () => {}
        )
      }

      const getLegalEmployerTypes = async () => {
        const {data: legalEmployerTypes} = await SharedApi.getCategoryById(2)
        // eslint-disable-next-line unicorn/consistent-function-scoping
        const convertName = name => {
          switch (name) {
            case 'In-House':
              return 'In-House Legal'
            case 'Private Practice':
              return 'Private Practice Law Firm'
            default:
              return name
          }
        }

        vm.legalEmployerTypes = legalEmployerTypes.specialties.map(
          ({name, id}) => {
            return {name: convertName(name), isSelected: false, id}
          }
        )

        vm.legalEmployerTypes = [
          ...vm.legalEmployerTypes,
          {
            name: 'Other',
            isSelected: false,
            id: undefined,
          },
        ]
      }

      // eslint-disable-next-line complexity
      vm.initializeAboutYouPage = async () => {
        startSpinner()

        vm.user = await userService.getUser()
        if ($location.search().user && !vm.user.isAdmin) {
          $location.url('/views/pages/404.html')
        }

        if (!$location.search().user && vm.user.isAdmin) {
          $location.url(vm.user.defaultRoute)
        }

        const userId =
          $location.search().user && vm.user.isAdmin
            ? Number($location.search().user)
            : vm.user.id
        try {
          const {data: candidate} = await CandidateProfileApi.getUserProfile(
            userId,
            {
              include: [
                'nationalities',
                'preferredContractTypes',
                'location',
                'preferredLocations',
              ],
            }
          )
          vm.candidate = candidate
        } catch (error) {
          let notifyMessage = `Error occurred in Initalizing User Profile Page`
          if (error.status === 404 && vm.user.isAdmin)
            notifyMessage = `Unable to Access User About You Profile`
          logger.notify('error', notifyMessage)
        }

        const [
          {data: locationsList},
          {data: nationalitiesList},
          {data: schoolList},
          {data: employersList},
          {data: legalPracticeAreaList},

          {data: legalJurisdictionList},
          {data: resumes},
        ] = await Promise.all([
          SharedApi.getAllLocations({
            regions: true,
          }),
          SharedApi.getAllNationalities(),
          SharedApi.getAllSchools(),
          EmployersApi.getAllEmployers({
            isDeleted: false,
            include: ['id', 'name'],
            isApproved: true,
          }),
          SharedApi.getCategoryById(1),
          SharedApi.getCategoryById(3),
          CandidateProfileApi.getUserResumes(userId),
        ])

        vm.nationalitiesList = nationalitiesList
          .map(nationality => {
            return {
              code: nationality.code,
              name: nationality.demonyms[0],
            }
          })
          .filter(nationality => nationality.name)

        vm.locationsList = locationsList
        vm.schoolList = schoolList
        vm.employersList = employersList
        vm.legalPracticeAreaList = legalPracticeAreaList.specialties

        vm.legalJurisdiction = legalJurisdictionList.specialties
        vm.candidate.resumes = resumes

        vm.candidate.isNewUser = vm.candidate.approvalStatus === 'New User'
        vm.candidate.university = vm.candidate.schoolId
          ? vm.schoolList.find(({id}) => id === vm.candidate.schoolId)
          : undefined

        vm.candidate.resume =
          vm.candidate.resumes && vm.candidate.resumes.length > 0
            ? vm.candidate.resumes[vm.candidate.resumes.length - 1]
            : undefined
        if (vm.candidate.preferredLocations.length > 0)
          vm.candidate.preferredLocations = vm.candidate.preferredLocations.map(
            location => {
              location.isSelected = true
              return location
            }
          )
        vm.selectedLocation = vm.candidate.preferredLocations.length > 0

        vm.candidate.legalPracticeAreaSpecialties = vm.candidate.category.find(
          category => category.id === 1
        )
        if (
          vm.candidate.legalPracticeAreaSpecialties &&
          vm.candidate.legalPracticeAreaSpecialties.specialties.length > 0
        )
          vm.candidate.specialties =
            vm.candidate.legalPracticeAreaSpecialties.specialties
        vm.candidate.specialties = vm.candidate.specialties
          ? vm.candidate.specialties.map(specialty => {
              specialty.isSelected = true
              return specialty
            })
          : []
        vm.selectedPracticesShow = vm.candidate.specialties.length > 0

        const candidateJurisdictions = vm.candidate.category.find(
          category => category.id === 3
        )
        vm.candidate.legalJurisdictions = vm.legalJurisdiction.map(
          jurisdiction => {
            return Object.assign(
              {
                isSelected: Boolean(
                  candidateJurisdictions &&
                    candidateJurisdictions.specialties.find(
                      candidateJurisdiction =>
                        candidateJurisdiction.id === jurisdiction.id
                    )
                ),
              },
              jurisdiction
            )
          }
        )
        vm.jurisdictionShow = vm.candidate.legalJurisdictions.find(
          ({isSelected}) => isSelected === true
        )

        vm.isEnglandWalesSelected = vm.candidate.legalJurisdictions.find(
          ({isSelected, name}) =>
            isSelected === true && name === 'England & Wales'
        )
        vm.candidate.phone = vm.candidate.user.phone
        vm.candidate.location = vm.candidate.location
          ? vm.candidate.location.id
          : undefined
        vm.candidate.nationality =
          vm.candidate.nationalities && vm.candidate.nationalities.length > 0
            ? vm.candidate.nationalities
                .map(nationality => {
                  return {
                    code: nationality.code,
                    name: nationality.demonyms[0],
                  }
                })
                .find(nationality => nationality.name)
            : undefined
        vm.candidate.pqe = vm.candidate.lawProfile.qualificationDate
        vm.candidate.sraId = vm.candidate.lawProfile.sraId

        vm.isNewCandidate = angular.copy(vm.candidate)
        vm.requestAccessBtnLabel = vm.candidate.isNewUser
          ? 'Request Access'
          : 'Access Requested'
        vm.requestAccessBtnClass =
          vm.requestAccessBtnLabel === 'Access Requested'
            ? 'btn btn-lg btn-info disabled'
            : 'btn btn-lg btn-info'

        fetchSelectedEmployer()
        stopSpinner()

        $scope.$apply()
      }

      getLegalEmployerTypes()
      vm.initializeAboutYouPage()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/about-you/about-you.ctrl.js